<red-header-content>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button [defaultHref]="defaultHref"></ion-back-button>
    </ion-buttons>
    <ion-title>Save Walking Farm&#174;</ion-title>
  </ion-toolbar>
</red-header-content>
<red-page-content>
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <ion-card>
      <ion-card-header class="tw:pb-0">
        <ion-card-subtitle class="tw:text-center">
          All Properties: <b>{{ totalProperties }}</b>
        </ion-card-subtitle>
      </ion-card-header>
      <ion-card-content>
        @if (turnoverRateEnabled) {
          <red-chart [options]="chartOptions"></red-chart>
        }
      </ion-card-content>
    </ion-card>

    <div class="tw:m-4 tw:text-xs">
      <ion-note color="warning">
        @for (message of messages; track message) {
          <div class="tw:mb-4">{{ message }}</div>
        }
      </ion-note>
    </div>

    <ion-list [inset]="true" lines="full" class="no-last-line">
      <ion-item>
        <ion-input
          redErrorMessage
          [required]="true"
          labelPlacement="stacked"
          placeholder="My new farm"
          inputmode="text"
          type="text"
          formControlName="name"
        >
          <div slot="label">Name:<ion-text color="danger">*</ion-text></div>
        </ion-input>
      </ion-item>
    </ion-list>
    <ion-button fill="outline" class="tw:m-4" expand="block" [routerLink]="defaultHref" routerDirection="back">
      Edit<ion-icon slot="start" src="/assets/svg/pencil.svg"></ion-icon>
    </ion-button>
    <ion-button class="tw:m-4" expand="block" (click)="onSubmit()" [disabled]="!form.valid">
      Save<ion-icon slot="start" src="/assets/svg/save-file.svg"></ion-icon>
    </ion-button>
  </form>
</red-page-content>
